import { InputText } from "primereact/inputtext";
import { TextDisplayFieldProps } from "./text-display-field.interface";

export const TextDisplayField = ({ label, value }: TextDisplayFieldProps) => {
	return (
		<div className="field col">
			<label htmlFor={value} className="col-fixed">
				{label}
			</label>
			<InputText id={value} className="w-full" value={value} />
		</div>
	);
};
